import { Table2 } from "lucide-react";
import {
  GenericTableParamsSchema,
  defaultGenericTableParams,
  type GenericTableParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { GenericTableWidget } from "./Component.js";
import { GenericTableExpandedEditor } from "./ExpandedEditor.js";

export const genericTableDef: WidgetDef<GenericTableParams> = {
  kind: "genericTable",
  label: "Structured Table",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 560, h: 320 },
  defaultParams: defaultGenericTableParams,
  Component: GenericTableWidget,
  ExpandedComponent: GenericTableExpandedEditor,
  expandable: true,
  storage: "sql",
  schema: GenericTableParamsSchema,
  accent: "neutral",
  icon: Table2,
  subtitle: "Typed rows and columns",
  defaultRoster: false,
  category: "multi",
  layout: { col: "full", row: 0, width: 560, height: 296 },
  askAiPrompt: "Help me review this structured table.",
  renderFooter: (data) => ({
    left: `${data.rows.length} rows`,
    right: data.binding
      ? `Source: ${data.binding.skillId}`
      : "Source: this SOLVE",
  }),
};

registerWidget(genericTableDef);
